enum NotificationLevel {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    DEBUG = 'DEBUG',
}

export const NotificationLevelMapping = [
    NotificationLevel.INFO,
    NotificationLevel.WARNING,
    NotificationLevel.ERROR,
    NotificationLevel.DEBUG,
];

export default NotificationLevel;

export const AllNotificationLevels = [
    NotificationLevel.INFO,
    NotificationLevel.WARNING,
    NotificationLevel.ERROR,
    NotificationLevel.DEBUG,
];
